import {Moment } from 'moment';

export abstract class ItemOrderHistoryBase<T extends { visible: boolean}> {
    protected constructor(
        public readonly orderId: number,
        public readonly date: Moment,
        public readonly planArriveDate: Moment,
        public readonly order: string,
        public readonly distOrder: number,
        public readonly status: number,
        public readonly statusDesc: string,
        public readonly statusDescStyle: number,
        public readonly fulfillment: number,
        public readonly fulfillmentDesc: string,
        public readonly fulfillmentDescStyle: number,
        public readonly arrivalDate: Moment,
        public readonly arrivedQuantity: number,
        public readonly supplierCode: string,
        public readonly supplierName: string,
        public readonly buffer: number,
        public readonly safetyStock: number,
        public readonly balance: number,
        public readonly inTransit: number,
        public readonly need: number,
        public readonly hasData: string,
        public readonly hasMoq: string,
        public readonly hasMoa: string,
        public readonly extraAttribute: string,
        isCwh: boolean,
        public readonly crossDock: T) {
        this.isCwhOrder = isCwh;
        this.visible = true;
        if (this.crossDock)
            this.crossDock.visible = false;
    }

    readonly isCwhOrder: boolean;

    visible: boolean;

    hiddenByFilter: boolean;

    get id(): string {
        return `${this.orderId}`;
    }
}





// WEBPACK FOOTER //
// ./src/app/buffer-graph/models/item-order-history/item-order-history-base.ts